function algoliaColorSwatchesInit() {
  const query = document.querySelectorAll('.aa-ProductItem[data-unswatched]');
  query.forEach((prodItem) => {
    let variantColorHandles = '';
    const rollupJson = prodItem.querySelector('.rollupJSON');
    if (!rollupJson) return;
    prodItem.removeAttribute('data-unswatched');

    variantColorHandles = JSON.stringify(
      prodItem
        ?.querySelector('[data-variant-info]')
        ?.getAttribute('data-variant-info')
        ?.split(','),
    );

    const colorJSON = variantColorHandles && JSON.parse(variantColorHandles);
    const currentProductHandle = prodItem
      .querySelector('[data-prod-handle]')
      .getAttribute('data-prod-handle');
    colorJSON.push(currentProductHandle);
    let colorsElement;
    const ajaxCalls = [];
    const allColors = [];

    const promiseState = (p) => p.then(
      (v) => ({ v, status: 'fulfilled' }),
      (e) => ({ e, status: 'rejected' }),
    );
    colorJSON.forEach((handle) => {
      if (!handle || handle === '[]' || handle.length === 0) return;
      const cleanedHandle = handle?.trim().replace(/['"]+/g, '').replace('[', '').replace(']', '');
      // check if the handle is already in sessionStorage but only for US
      if (sessionStorage.getItem(`${cleanedHandle}`) !== null && window.Shopify?.country === 'US') {
        const itemFromStorage = JSON.parse(sessionStorage.getItem(cleanedHandle));
        allColors.push(itemFromStorage);
      } else if (handle) {
        ajaxCalls.push(
          fetch(`${window.Shopify.routes.root}products/${cleanedHandle}?view=json`)
            .then((response) => response.json())
            .then((parsedContent) => {
              allColors.push(parsedContent);
              if (window.Shopify?.country === 'US') {
                sessionStorage.setItem(cleanedHandle, JSON.stringify(parsedContent));
              }
            })
            .catch((error) => {
              console.warn('not valid JSON for product handle:', cleanedHandle, error);
            }),
        );
      }
    });
    try {
      Promise.all(ajaxCalls.map(promiseState)).then(() => {
        // Sort all the colors alphabetically
        allColors.sort((a, b) => {
          const colorA = a.color;
          const colorB = b.color;
          if (colorA < colorB) return -1;
          if (colorA > colorB) return 1;
          return 0;
        });
        rollupJson.innerText = JSON.stringify(allColors);

        // place current product first in allColors array
        allColors.forEach((colorObj, index) => {
          colorObj.index = index;
          if (colorObj.handle === currentProductHandle) {
            allColors.splice(index, 1);
            allColors.unshift(colorObj);
          }
        });

        // Get the localized price
        const isDefaultLocale = Shopify?.routes?.root === '/';
        const $compareAtPrice = prodItem.querySelector('.js-compare-price');
        const $price = prodItem.querySelector('.price__sale .js-price');
        const $priceNoDiscount = prodItem.querySelector('.js-price-no-discount');
        if (allColors.length > 0) {
          if ($compareAtPrice && $price && !isDefaultLocale) {
            $compareAtPrice.innerText = allColors[0].first_variant_compare_at_price;
            $price.innerHTML = allColors[0]?.first_variant_price;
            $price.classList.remove('hide');
          } else if ($priceNoDiscount && !isDefaultLocale) {
            $priceNoDiscount.innerHTML = allColors[0].first_variant_price;
          }
        }

        let activeIndex = 0;
        // Loop through each color
        allColors.forEach((colorObj, index) => {
          const productId = colorObj.id;
          const colorId = `color--${colorObj.id}`;
          const productHandle = colorObj.handle;
          const productTitle = colorObj.title.split(" - ")[0];

          retrieveProduct(index, colorsElement, colorObj, 'product', prodItem);

          // Generating the images
          // Get the rest of the Images
          let imageContent = '';
          let slideshowImages = '';
          let slideShowImageContent = '';

          colorObj.images.forEach((img, index2) => {
            const image = img.src;
            const imageId = img.id;
            const imageAspectRatio = img.aspect_ratio;
            let isVideo = false;
            if (index2 === colorObj.images.length - 1) return; // doesn't include the last image
            if (img.alt === 'featured' || img.alt === 'featured mobile') { return; }
            if (
              img.alt.indexOf('youtube.com/embed') > -1
              || img.alt.indexOf('player.vimeo.com') > -1
            ) { isVideo = true; }

            imageContent = `
              ${imageContent}
              <span
                data-image-id="${imageId}"
                data-color-id="${colorId}"
                class="Product__SlideshowNavImage ${isVideo ? 'Product__SlideshowNavImage--video' : ''} AspectRatio ${index2 === 0 ? 'is-selected' : ''}"
                style="--aspect-ratio: ${imageAspectRatio}"
              >
                <img
                  data-src="${image}"
                  class="Image--lazyLoad"
                  height="160"
                  width="160"
                  style="height: 160px; width: 160px;"
                >
                  ${isVideo ? '<button type="button" class="Product__SlideshowNavPlay" data-action="play-video"></button>' : ''}
              </span>
            `;
          });
          const prodItemSwatchesArray = Array.from(prodItem.querySelectorAll('.pdp--legacy-swatch__container'));

          const activeSwatchIndex = prodItemSwatchesArray
            .findIndex(($swatchContainer) => $swatchContainer.dataset.active === 'true');
          activeIndex = activeSwatchIndex;

          if (index === activeSwatchIndex || (activeSwatchIndex === -1 && index === 0)) {
            colorObj.images.forEach((img, imgIndex) => {
              if (img.alt === 'color_swatch') return;
              const imageAlt = `Visit ${colorObj.title.split('-')[0]?.trim()} product page for more details`;
              const imageId = img.id;
              const imageSrc = img.src;
              const newImageSrc = imageSrc.replace(/&width=\d+/, '');
              const imageAspectRatio = 0.8005347593582888;
              const imageWidth = img.width;
              const imageHeight = img.height;
              const paddingBottomCalculation = 100.0 / imageAspectRatio;
              const initialImageId = img.featured_image_id;
              const widths = [135, 317, 634];
              const { algoliaPosition } = prodItem.dataset;

              let srcset = '';
              // Generate srcset for different widths
              widths.forEach((width) => {
                if (imageSrc.includes('?')) {
                  srcset += `${newImageSrc}&width=${width} ${width}w, `;
                } else {
                  srcset += `${newImageSrc}?width=${width} ${width}w, `;
                }
              });
              // Remove trailing comma and space
              srcset = srcset.slice(0, -2);

              let imgTag = `
                  <img
                    class="Image--fadeIn card__image lazyload"
                    ${imgIndex >= 1 ? `loading="lazy"` : `loading="eager"`}
                    data-expand="-100"
                    alt="${imageAlt}"
                    width="317"
                    height="395"
                    data-max-width="${imageWidth}"
                    data-max-height="${imageHeight}"
                    data-src="${imageSrc}"
                    data-srcset="${srcset}"
                    data-sizes="auto"
                  >
              `;

              if (imgIndex === 0 && algoliaPosition === '1') {
                imgTag = `
                  <img
                    class="Image--fadeIn card__image"
                    loading="eager"
                    fetchpriority="high"
                    alt="${imageAlt}"
                    width="317"
                    height="395"
                    src="${imageSrc}"
                    srcset="${srcset}"
                    sizes="auto"
                  >
                `;
              }

              slideShowImageContent = `
                <div class="card__image-wrapper">
                  <div
                    class="AspectRatio AspectRatio--withFallback card__image-aspect-ratio"
                    style="padding-bottom: ${paddingBottomCalculation}%; --aspect-ratio: ${imageAspectRatio}"
                  >
                    ${imgTag}
                    <span class="Image__Loader"></span>
                    <noscript>
                      <img src="${imageSrc}"
                        loading="eager"
                        alt="${imageAlt}"
                        width="${imageWidth}"
                        height="${imageHeight}"
                        style="width: 317px; height: 395px;"
                      >
                    </noscript>
                  </div>
                </div>
              `;

              slideshowImages = `
                ${slideshowImages}
                <div id="Image${imageId}"
                data-product-id="${productId}"
                data-product-handle="${productHandle}"
                class="Product__SlideItem Product__SlideItem--image card__image-slide Carousel__Cell ${imageId === initialImageId ? 'is-selected' : ''}"
                data-image-position-ignoring-video=${imgIndex}
                data-image-position="${imgIndex}"
                data-image-id="${imageId}"
                role="group"
                aria-label="product item">
                  ${slideShowImageContent}
                </div>
              `;
            });
            const $plpPlaceholder = prodItem.querySelector('.js-plp-image-placeholder');
            if ($plpPlaceholder) $plpPlaceholder.classList.add('hide');
            prodItem.querySelector('._ais-hit--picture')
              .innerHTML = `
              <div class="card__image-carousel" role="region" aria-label="image carousel for ${productTitle}">
                ${slideshowImages}
              </div>
            `;
          }
        });

        if (activeIndex < 0) {
          prodItem.querySelectorAll('.pdp--legacy-swatch__container').forEach(($swatchContainer, index) => {
            if (index === 0) {
              $swatchContainer.dataset.active = 'true';
            } else {
              $swatchContainer.dataset.active = 'false';
            }
          });
        }

        const $carousel = prodItem.querySelector('.card__image-carousel') || null;
        // A/B test to swap first and second images
        if (SDG.Data.abShowFlatlay) {
          window.swapFirstAndSecondImages($carousel);
        }

        if ($carousel && window?.Flickity) {
          // eslint-disable-next-line no-new
          const flick = new window.Flickity($carousel, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            adaptiveHeight: true,
            lazyLoad: true,
          });

          flick.on('scroll', () => {
            const $images = $carousel.querySelectorAll('.card__image');
            $images.forEach((img) => {
              _.addClass(img, 'lazypreload');
            });
          });

          const carouselClickHandler = (event) => {
            const isButton = event.target.classList.contains('flickity-button') || event.target.closest('.flickity-button-icon');
            if (!isButton) return;
            event.preventDefault();
          };

          // Add click event for keyboard accessible buttons
          // to prevent the link from firing
          $carousel.addEventListener('click', carouselClickHandler);

          const srSpan = document.createElement("span");
          srSpan.className = "screenreader";
          srSpan.textContent = "This is a carousel with product images. Use the previous and next buttons to navigate.";
          $carousel.prepend(srSpan);
        }

        const availableSwatches = prodItem?.querySelectorAll(
          '.swatch-list [data-swatch-prod-available="true"]',
        );
        const firstSwatchCount = availableSwatches?.length || 0;
        const colorText = prodItem?.querySelector('.available-colors p');

        if (firstSwatchCount > 1 && colorText) {
          colorText.innerHTML = `${firstSwatchCount} color options`;
        }

        document.dispatchEvent(new CustomEvent('swatches:loaded'));

        // format product card URLs for localization
        const formatUrl = (href) => {
          const shopifyRoot = Shopify?.routes?.root;
          if (shopifyRoot === '/' || href.includes(shopifyRoot)) { return href; }
          const hrefSplit = href.split('/');
          const hostnameIndex = hrefSplit.findIndex(
            (split) => split === window.location.hostname,
          );
          const rawRoot = shopifyRoot.replace('/', '').replace('/', '');
          const rootIndex = hostnameIndex + 1;
          hrefSplit.splice(rootIndex, 0, rawRoot);
          const localizedUrl = hrefSplit.join('/');
          return localizedUrl || href;
        };

        const $cardMedia = prodItem.querySelector('.card__media');
        if ($cardMedia) $cardMedia.href = formatUrl($cardMedia.href);

        if (prodItem.querySelector('.swatch-list .more-label')) {
          const swatchIndex = prodItem
            .querySelector('.swatch-list .more-label')
            .getAttribute('data-extra-swatch-num');
          const handle = prodItem.querySelector('.card__media')?.href;
          if (handle) {
            prodItem.querySelector('.swatch-list .more-label').href = handle;
          }
          prodItem.querySelector(
            '.swatch-list .more-label',
          ).innerHTML = `+${swatchIndex} ${SDG.Data.translations.collections.more_color_label}${swatchIndex > 1 ? 's' : ''}`;
        }
      });
    } catch (error) {
      console.error('error', error);
    }
  });
}

window.algoliaColorSwatchesInit = algoliaColorSwatchesInit;

function createSizedImageUrl(src, width) {
  if (typeof src !== 'string' || !width) {
    return src;
  }
  const indexOfLastDot = src.lastIndexOf('.');
  const name = src.substr(0, indexOfLastDot);
  const extension = src.substr(indexOfLastDot);
  return `${name}_${width}x${extension}`;
}

function createSwatchSrcSet(src) {
  const transformedSrcSet = `${window.createSizedImageUrl(
    src,
    20,
  )} 1x, ${window.createSizedImageUrl(src, 40)} 2x`;
  return transformedSrcSet;
}

window.createSwatchSrcSet = createSwatchSrcSet;

function retrieveProduct(
  index,
  colorsElement,
  colorObj,
  retrieveType,
  prodItem,
  productInfo,
  specificProductRelatedColors,
) {
  let colorSwatch = '';
  let currentProductHandle = '';
  let formColors = '';

  if (retrieveType === 'product') {
    formColors = document.querySelector('.js-form-colors');
  } else {
    currentProductHandle = productInfo.dataset.productHandle;
    formColors = specificProductRelatedColors;
  }

  const defaultProductHandle = prodItem.querySelector('[data-prod-handle]').getAttribute('data-prod-handle');
  currentProductHandle = colorObj.handle;
  const useFlatLay = document.querySelector('[data-use-flat-lay]') !== 'false';
  const colorHex = colorObj.metafields[0].swatch_hex;
  const colorName = colorObj.color;
  const swatchType = colorObj.metafields[0].swatch_type || '';
  let metaImage = colorObj.metafields[0].swatch_img;

  // bug fix when sometimes the metafield is an object
  if (metaImage && typeof metaImage === 'object') {
    metaImage = metaImage.src;
  }

  const flatLayImage = colorObj.images.find((img) => img.alt.includes('flatlay'))?.src;

  const colorURL = colorObj.url;
  const colorId = `color--${colorObj.id}`;
  const colorTitle = colorObj.color.toLowerCase();
  const featImg = useFlatLay && flatLayImage ? flatLayImage : colorObj.featured_image;
  const colorPrice = colorObj.first_variant_price;
  const colorComparePrice = colorObj.first_variant_compare_at_price;
  const productId = colorObj.id;
  const productAvailability = colorObj.available;
  const isImage = swatchType.toLowerCase().includes('image');

  let isActive = false;

  if (defaultProductHandle === currentProductHandle) {
    isActive = true;
  }

  // Get the color hexcode/image for swatches based on metaObject Value
  if (isImage) {
    colorSwatch = `background-image: url('${createSizedImageUrl(
      metaImage,
      50,
    )}'); background-size: contain;`;
  } else if (swatchType.toLowerCase().includes('hex')) {
    colorSwatch = `background-color: ${colorHex};`;
  } else {
    colorSwatch = 'background-color: gray;';
  }
  // Set OOS Badge
  if (!productAvailability && isActive) {
    const oosBadgeHTML = `
      <div class="ProdBadge__text-wrap" style="background-color:${SDG.badge_settings.oos_badge_color}">
        ${SDG.Data.translations.product.out_of_stock}
      </div>
    `;
    const $prodBadge = prodItem.querySelector('.js-prod-badge');
    if ($prodBadge) $prodBadge.innerHTML = oosBadgeHTML;
  }

  function getLuminance(hex) {
    const rgb = hex.replace('#', '').match(/.{2}/g).map(c => {
      const val = parseInt(c, 16) / 255;
      return val <= 0.03928
        ? val / 12.92
        : Math.pow((val + 0.055) / 1.055, 2.4);
    });

    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
  }

  // Inserting the color swatches
  if (!productInfo || !specificProductRelatedColors) {
    const parsedColorTitle = productAvailability
      ? colorTitle
      : `${colorTitle}: ${SDG.Data.translations.product.out_of_stock}`;
    const swatchOutput = isImage
      ? `background-image: url(${createSizedImageUrl(metaImage, 50)})`
      : `${colorSwatch}`;

    const randomId = Math.random().toString(36).substr(2, 9);
    const inputId = `${prodItem.id}-${colorId}-${randomId}`;
    colorsElement = `
      <input type="radio" id="${inputId}" name="${prodItem.id}" class="screenreader pdp--legacy-swatch__radio-input"  onchange="swatchChange('${inputId}')">
      <label for="${inputId}" data-index="${colorObj.index}" data-id='${colorObj.id}' data-color-name="${colorName}" data-href="${colorURL}" data-price="${colorPrice}" data-compare-at-price="${colorComparePrice}" data-feat-img="${featImg}" class="pdp--legacy-swatch__container" data-active="${isActive}" style="${swatchOutput}">
        <span class="screenreader">${parsedColorTitle}</span>
      </label>
    `;
  }

  let luminanceClass = '';
  if (!isImage && /^#([0-9a-f]{3}){1,2}$/i.test(colorHex?.trim())) {
    const luminance = getLuminance(colorHex?.trim());
    luminanceClass = luminance > 0.5 ? 'is-light' : 'is-dark';
  }

  const divElement = document.createElement('div');
  divElement.innerHTML = colorsElement;
  const fieldset = prodItem.querySelector('.swatch-list__fieldset')

  if (fieldset.childElementCount <= 4) {
    divElement.setAttribute('data-swatch-prod-available', productAvailability);
    divElement.classList.add('swatch-wrapper');
    if (luminanceClass) divElement.classList.add(luminanceClass);
    fieldset.appendChild(divElement);
  } else if (!prodItem.querySelector('.swatch-list .more-label')) {
    const extraSwatchesLabel = document.createElement('button');
    extraSwatchesLabel.classList.add('more-label');
    extraSwatchesLabel.setAttribute('href', '#');
    extraSwatchesLabel.setAttribute('data-extra-swatch-num', 1);
    prodItem.querySelector('.swatch-list').appendChild(extraSwatchesLabel);
    extraSwatchesLabel.innerHTML = colorsElement;
  } else {
    let swatchIndex = +prodItem
      .querySelector('.swatch-list .more-label')
      .getAttribute('data-extra-swatch-num');
    swatchIndex += 1;
    prodItem
      .querySelector('.swatch-list .more-label')
      .setAttribute('data-extra-swatch-num', swatchIndex);
  }
  if (colorObj.handle !== 'psycho-bunny-gift-box' && formColors) {
    // Add color DOM
    formColors.insertAdjacentHTML('beforeend', colorsElement);
  }
}

window.retrieveProduct = retrieveProduct;
// end of swatch insert

function swatchChange(inputId) {
  const swatch = document.getElementById(inputId);
  const label = swatch.nextElementSibling;
  const container = label.closest('.ProductItem');
  const prodAvail = label.parentElement.getAttribute(
    'data-swatch-prod-available',
  );

  const imgMain = container.querySelector('.img-main');
  if (imgMain) {
    imgMain.src = label.getAttribute('data-feat-img');
  }
  const href = label.getAttribute('data-href');
  container.querySelectorAll('a').forEach(($link) => {
    $link.href = href;
  });
  container
    .querySelector('.pdp--legacy-swatch__container[data-active="true"]')
    ?.removeAttribute('data-active');
  const onSale = !!label.getAttribute('data-compare-at-price') && (label.getAttribute('data-compare-at-price') !== label.getAttribute('data-price'));
  if (prodAvail === 'true' && !onSale) {
    container.querySelector('.card__badge')?.classList.add('hide-badge');
    container.querySelector('.card__badge')?.setAttribute('aria-hidden', true);
  } else {
    container.querySelector('.card__badge')?.classList.remove('hide-badge');
    container.querySelector('.card__badge')?.removeAttribute('aria-hidden');
  }
  label.setAttribute('data-active', 'true');

  const $carousel = container.querySelector('.js-plp-item-carousel');
  if (window.Flickity && $carousel) {
    window.Flickity.data($carousel)?.select(0);
  }

  const displayPercentOff = function displayPercentOff(compareAtPrice, price) {
    // Calculate the percentage saved
    const percentageSaved = Math.round(100 - ((price / compareAtPrice) * 100));
    return `${percentageSaved.toFixed(0)}% off`;
  };

  const swatchIndex = Number(label.dataset.index);
  const prodData = JSON.parse(container.querySelector('.rollupJSON').innerHTML);
  const compareAtPrice = prodData[swatchIndex].compare_at_price;
  const price = prodData[swatchIndex].price;

  const showPercentageOff = window.SDG?.badge_settings.show_percentage_off_badge;
  const percentBGHex = window.SDG?.badge_settings.percentage_off_badge_color;
  const percentTextHex = window.SDG?.badge_settings.percentage_off_badge_text_color;

  const priceHtml = `
    <span class="visually-hidden visually-hidden--inline sale-price js-format-price">${label.getAttribute('data-price')}</span>
    ${onSale ? `
      <div class="price__sale price-sale--flex">
        <div>
          <span class="price-item price-item--sale-red price-item--last js-price js-format-price">${label.getAttribute('data-price')}</span>
          <span class="strikethrough-price-item js-compare-price">
            ${label.getAttribute('data-compare-at-price')}
          <span>
        </div>
        <div class="percent-off__badge"
        style="background-color: ${percentBGHex};
        color: ${percentTextHex}">
        ${showPercentageOff === true ? `${displayPercentOff(compareAtPrice, price)}` : ''}</div>
      </div>
      </div>
    ` :
      `<span class="price-item price-item--sale price-item--last js-price js-format-price">
        ${label.getAttribute('data-price')}
      </span>`
    }
  `;
  const innerPrice = container.querySelector('.ais-hit--price');

  if (innerPrice) {
    innerPrice.innerHTML = priceHtml;
  }

  updateCarousel(container, swatchIndex);
  window.SDG.currencyFormatter().init();
}

window.swatchChange = swatchChange;

/**
 * Update Carousel
 * @param {element} $container Product Item Container
 * @param {number} swatchIndex Clicked Swatch Index
 */
function updateCarousel($container, swatchIndex) {
  const prodData = JSON.parse($container.querySelector('.rollupJSON').innerHTML);
  const {
    images,
    id: productId,
    handle: productHandle,
  } = prodData[swatchIndex];
  let slideshowImages = '';
  let slideShowImageContent = '';
  const $imageContainer = $container.querySelector('._ais-hit--picture');
  images.forEach((img, imgIndex) => {
    if (img.alt === 'color_swatch') return;
    const imageAlt = img.alt;
    const imageId = img.id;
    const imageSrc = img.src;
    const imageWidth = img.width;
    const imageHeight = img.height;
    const imageAspectRatio = img.aspect_ratio;
    const paddingBottomCalculation = 100.0 / imageAspectRatio;
    const initialImageId = img.featured_image_id;
    slideShowImageContent = `
    <div class="card__image-wrapper">
      <div class="AspectRatio AspectRatio--withFallback card__image-aspect-ratio" style="padding-bottom: ${paddingBottomCalculation}%; --aspect-ratio: ${imageAspectRatio}">
        <img class="Image--lazyLoad Image--fadeIn card__image"
          src="${imageSrc}"
          data-widths="[200,400,600,700,800,900,1000,1200,1400,1600]"
          data-sizes="auto"
          data-expand="-100"
          alt="${imageAlt}"
          data-max-width="${imageWidth}"
          data-max-height="${imageHeight}"
          data-original-src="${imageSrc}">

        <span class="Image__Loader"></span>

        <noscript>
          <img src="${imageSrc}" alt="${imageAlt}" style="width: 800px; height: 800px;">
        </noscript>
      </div>
    </div>
  `;

    slideshowImages = `
    ${slideshowImages}
    <div id="Image${imageId}"
    data-product-id="${productId}"
    data-product-handle="${productHandle}"
    class="Product__SlideItem Product__SlideItem--image card__image-slide Carousel__Cell ${imageId === initialImageId ? 'is-selected' : ''}"
    data-image-position-ignoring-video=${imgIndex}
    data-image-position="${imgIndex}"
    data-image-id="${imageId}">
      ${slideShowImageContent}
    </div>
  `;
  });
  $imageContainer.innerHTML = `
    <div class="card__image-carousel" role="region" aria-label="image carousel">
      ${slideshowImages}
    </div>
  `;

  const $carousel = $container.querySelector('.card__image-carousel');
  // A/B test to swap first and second images
  if (SDG.Data.abShowFlatlay) {
    window.swapFirstAndSecondImages($container);
  }

  // eslint-disable-next-line no-new
  new window.Flickity($carousel, {
    cellAlign: 'left',
    contain: true,
    prevNextButtons: true,
    pageDots: false,
    adaptiveHeight: true,
    on: {
      ready: () => {
        // Hide buttons when only one slide
        const $carouselCells = $carousel.querySelectorAll('.Product__SlideItem');
        if ($carouselCells && $carouselCells.length === 1) {
          const $buttons = $carousel.querySelectorAll('.flickity-button');
          $buttons.forEach(($button) => {
            $button.style.display = 'none';
          });
        }
      }
    },
  });

  // Add click event for keyboard accessible buttons
  // to prevent the link from firing
  $carousel.addEventListener('click', (event) => {
    const isButton = event.target.classList.contains('flickity-button') || event.target.closest('.flickity-button-icon');
    if (!isButton) return;

    event.preventDefault();
  });

  const srSpan = document.createElement("span");
  srSpan.className = "screenreader";
  srSpan.textContent = SDG.Data.translations.accessibility.product_carousel;
  $carousel.prepend(srSpan);
}

window.updateCarousel = updateCarousel;
